module.exports = __webpack_public_path__ + "static/img/swiper2.e683ab42.png";